(function () {
  var root = document.querySelector('[data-ss-root]');
  if (!root) return;
  var variantData = JSON.parse(document.querySelector('[data-ss-variants]').textContent || '[]');
  var sizes = {};
  variantData.forEach(function (item) { sizes[item.size] = item; });
  var idToSize = {};
  Object.keys(sizes).forEach(function (size) { idToSize[sizes[size].id] = size; });

  function setVariant(id) {
    root.dataset.variantId = id;
    var size = idToSize[id] || '9';
    var selected = sizes[size];
    document.querySelectorAll('[data-ss-size-option]').forEach(function (button) {
      var active = button.dataset.value === String(id);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('[data-ss-size-label]').forEach(function (label) { label.textContent = size; });
    document.querySelectorAll('[data-ss-add]').forEach(function (button) {
      button.disabled = !selected.available;
      button.textContent = (selected.available ? 'Add to cart · ' : 'Sold out · ') + selected.label;
    });
    status(selected.available ? selected.label + ' is in stock.' : selected.label + ' is sold out.');
  }
  document.querySelectorAll('[data-ss-size-option]').forEach(function (button) { button.addEventListener('click', function () { setVariant(button.dataset.value); }); });

  var featureCopy = {
    toe: ['01 · Reinforced toe', 'Take the knock.', 'Extra structure at the front handles curbs, tools, gravel, and the ordinary collisions of a working day.'],
    upper: ['02 · Seamless upper', 'Water has nowhere to start.', 'Neoprene and rubber form a flexible waterproof shell without exposed upper seams.'],
    pull: ['03 · Front + back pulls', 'A handhold on either side.', 'Two generous pull tabs make the low opening quick to grab, even when the other hand is full.'],
    kick: ['04 · Heel kick', 'Step out without reaching down.', 'A molded ledge gives the opposite foot a place to press for easy, hands-free removal.'],
    sole: ['05 · Certified outsole', 'Grip wet ground. Respect clean floors.', 'The independently certified slip-resistant outsole is also non-marking for the walk back inside.']
  };
  var tooltip = document.querySelector('[data-ss-tooltip]');
  function closeTooltip() {
    tooltip.hidden = true;
    document.querySelectorAll('[data-ss-feature]').forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-expanded', 'false');
    });
  }
  document.querySelectorAll('[data-ss-feature]').forEach(function (button) {
    button.addEventListener('click', function () {
      var key = button.dataset.ssFeature;
      var copy = featureCopy[key];
      var wasOpen = button.getAttribute('aria-expanded') === 'true';
      if (wasOpen) {
        closeTooltip();
        return;
      }
      document.querySelectorAll('[data-ss-feature]').forEach(function (item) { var active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-expanded', String(active)); });
      tooltip.dataset.position = key;
      tooltip.querySelector('small').textContent = copy[0];
      tooltip.querySelector('h3').textContent = copy[1];
      tooltip.querySelector('p').textContent = copy[2];
      tooltip.hidden = false;
    });
  });
  document.addEventListener('click', function (event) {
    if (tooltip.hidden || event.target.closest('[data-ss-feature]') || event.target.closest('[data-ss-tooltip]')) return;
    closeTooltip();
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !tooltip.hidden) closeTooltip(); });

  var unit = 'in';
  var lengthInput = document.querySelector('[data-ss-length]');
  var widthInput = document.querySelector('[data-ss-width]');
  document.querySelectorAll('[data-ss-unit]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.dataset.ssUnit === unit) return;
      var next = button.dataset.ssUnit;
      var factor = next === 'cm' ? 2.54 : 1 / 2.54;
      [lengthInput, widthInput].forEach(function (input) { if (input.value) input.value = (Number(input.value) * factor).toFixed(1); });
      unit = next;
      document.querySelectorAll('[data-ss-unit]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
      document.querySelectorAll('[data-ss-unit-label]').forEach(function (label) { label.textContent = unit; });
      lengthInput.placeholder = unit === 'cm' ? '26.4' : '10.4';
      widthInput.placeholder = unit === 'cm' ? '8.9' : '3.5';
    });
  });

  document.querySelector('[data-ss-find]').addEventListener('click', function () {
    var length = Number(lengthInput.value);
    var width = Number(widthInput.value);
    var result = document.querySelector('[data-ss-result]');
    if (!length || !width || length <= 0 || width <= 0) {
      result.querySelector('h3').textContent = 'Add both measurements';
      result.querySelector('p').textContent = 'Measure the larger foot from heel to longest toe and across its widest point.';
      return;
    }
    var lengthIn = unit === 'cm' ? length / 2.54 : length;
    var widthIn = unit === 'cm' ? width / 2.54 : width;
    var recommendation = Object.keys(sizes).find(function (size) { return sizes[size].lengthIn >= lengthIn + 0.25 && sizes[size].widthIn >= widthIn; });
    if (!recommendation) {
      if (lengthIn + 0.25 < sizes['9'].lengthIn && widthIn < sizes['9'].widthIn) {
        result.querySelector('h3').textContent = 'Below the size 9 range';
        result.querySelector('p').textContent = 'Your measurements fall below the sizes currently shown at Rarely. Check the full vendor size guide before choosing.';
      } else {
        result.querySelector('h3').textContent = 'Beyond the size 11 range';
        result.querySelector('p').textContent = 'Your measurements need more room than the sizes currently shown at Rarely. Check the full vendor size guide before choosing.';
      }
      return;
    }
    var fit = sizes[recommendation];
    setVariant(fit.id);
    result.querySelector('h3').textContent = 'Try men’s ' + recommendation + ' / women’s ' + fit.women;
    result.querySelector('p').textContent = 'This is the smallest displayed insole that allows about ¼ inch at the toe and accommodates the width you entered.';
  });

  function status(message) { document.querySelectorAll('[data-ss-status]').forEach(function (el) { el.textContent = message; }); }
  document.querySelectorAll('[data-ss-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      var selected = sizes[idToSize[root.dataset.variantId] || '9'];
      if (!selected.available) { setVariant(selected.id); return; }
      button.disabled = true;
      button.textContent = 'Adding…';
      var request = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(root.dataset.variantId), quantity: 1 }] }) });
      Promise.resolve(request).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }).then(function () {
        button.textContent = 'Added';
        status('River Clog added to your cart.');
        if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: [root.dataset.variantId], content_name: 'Soot & Soil River Clog', content_type: 'product', value: 95, currency: 'USD' });
        setTimeout(function () { setVariant(root.dataset.variantId); }, 1700);
      }).catch(function () { setVariant(root.dataset.variantId); status('This size is not available right now.'); });
    });
  });
  setVariant(root.dataset.variantId);

  var sticky = document.querySelector('[data-ss-sticky]');
  var hero = document.querySelector('[data-ss-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) new IntersectionObserver(function (entries) { sticky.classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: .08 }).observe(hero);
  else if (sticky) sticky.classList.add('is-visible');
  if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', { content_ids: [root.dataset.variantId], content_name: 'Soot & Soil River Clog', content_type: 'product', value: 95, currency: 'USD' });
})();
